<template>
  <!--
          作者 luoyiming
          时间：2020-06-09
          描述：健康证列表管理
      -->
  <div class="user">
    <div style="margin-bottom:20px">
      <el-radio-group v-model="formInline.status" @change="btnMenu">
        <el-radio-button label="all">全部</el-radio-button>
        <el-radio-button label="0">待审核</el-radio-button>
        <el-radio-button label="1">审核成功</el-radio-button>
        <el-radio-button label="2">驳回</el-radio-button>
      </el-radio-group>
    </div>

    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%">
          <el-table-column prop="waiterUser.username" align="center" label="技师名称"></el-table-column>
          <el-table-column prop="waiterUser.avatarUrl" align="center" label="技师头像">
            <template slot-scope="scope">
              <el-image v-if="scope.row.waiterUser && scope.row.waiterUser.avatarUrl" style="width:60px;height:60px"
                fit="cover" :src="scope.row.waiterUser.avatarUrl" alt=""
                :preview-src-list="[scope.row.waiterUser.avatarUrl]">
              </el-image>
            </template>
          </el-table-column>
          <el-table-column prop="server_score" align="center" label="服务分值">
            <template slot-scope="scope">
              <span style="color:red" v-if="scope.row.server_score <= 3">{{ scope.row.server_score }}分</span>
              <span style="color:green" v-else>{{ scope.row.server_score }}分</span>
            </template>
          </el-table-column>
          <el-table-column prop="content" align="center" label="评价内容"></el-table-column>
          <el-table-column label="评论图片" align="center">
            <template slot-scope="scope" v-if="scope.row.images">
              <div style="display: flex; width: 100%;">
                <el-image v-for="(item, index) in scope.row.images" :key='index' style="width:60px;height:60px"
                  :src="item" fit="cover" :preview-src-list="[item]"></el-image>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="status" align="center" label="是否审核">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.status == 0">待审核</el-tag>
              <el-tag v-if="scope.row.status == 1" type="success">已审核</el-tag>
              <el-tag v-if="scope.row.status == 2" type="danger">驳回</el-tag>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" align="center" width="160">
            <template slot-scope="scope">
              <el-button @click="editClick(scope.row)" type="primary" size="small"
                :disabled="scope.row.status != 0">审核</el-button>
              <el-button @click="deleteClick(scope.row)" type="danger" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
          :current-page="curPage" :page-size="pageSize" layout="total, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>
    <!--编辑-->
    <Edit v-if="open_edit" :open_edit="open_edit" :form="userModel" @closeDialog="closeDialogFunc($event, 'edit')"></Edit>
  </div>
</template>

<script>
import ProcessApi from "@/api/process.js";
import Edit from "./Edit.vue";
import { deepClone } from "@/utils/base.js";
export default {
  components: {
    /*编辑组件*/
    Edit
  },
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 15,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      formInline: {
        status: "all"
      },
      /*是否打开添加弹窗*/
      open_add: false,
      /*是否打开编辑弹窗*/
      open_edit: false,
      /*当前编辑的对象*/
      userModel: {}
    };
  },
  created() {
    /*获取列表*/
    this.getTableList();
  },
  methods: {
	  // 点击菜单
	  btnMenu() {
	  	this.curPage = 1
	  	this.getTableList();
	  },
    /*换行*/
    keepTextStyle(val) {
      let str = val.replace(/(\\r\\n)/g, "<br/>");
      return str;
    },

    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.loading = true;
      self.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*获取列表*/
    getTableList() {
      let self = this;
      let Params = self.formInline;
      Params.pageIndex = self.curPage;
      // Params.status = "";
      Params.pageSize = self.pageSize;
      ProcessApi.commentStatusList(Params, true)
        .then(data => {
          self.loading = false;
          if (data.code != 1) return;
          self.tableData = data.data.data;
          self.totalDataNumber = data.data.total;
        })
        .catch(error => { });
    },

    /*打开添加*/
    addClick() {
      this.open_add = true;
    },

    /*打开编辑*/
    editClick(item) {
      this.userModel = deepClone(item);
      this.open_edit = true;
    },

    /*关闭弹窗*/
    closeDialogFunc(e, f) {
      if (f == "edit") {
        this.open_edit = e.openDialog;
        if (e.type == "success") {
          this.getTableList();
        }
      }
    },

    /*删除用户*/

    deleteClick(row) {
      let self = this;
      self
        .$confirm("删除后不可恢复，确认删除该记录吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          ProcessApi.commentsetDelete({
            comment_id: row.comment_id
          }).then(data => {
            self.$message({
              message: "删除成功",
              type: "success"
            });
            self.getTableList();
          });
        });
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/technician/process/evaluate/list.vue